export var GVCInternalWebRTCTransportEvent;
(function (GVCInternalWebRTCTransportEvent) {
    GVCInternalWebRTCTransportEvent["WebRTCTransportConnectionStateChange"] = "webRTCTransportConnectionStateChange";
    GVCInternalWebRTCTransportEvent["WebRTCTransportError"] = "webRTCTransportError";
})(GVCInternalWebRTCTransportEvent || (GVCInternalWebRTCTransportEvent = {}));
export var WebRTCTransportErrorCode;
(function (WebRTCTransportErrorCode) {
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["Disconnected"] = 0] = "Disconnected";
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["FailedToConnect"] = 1] = "FailedToConnect";
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["FailedState"] = 2] = "FailedState";
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["ICERestartFailure"] = 3] = "ICERestartFailure";
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["RTCPeerConnectionException"] = 4] = "RTCPeerConnectionException";
    WebRTCTransportErrorCode[WebRTCTransportErrorCode["UnstableConnection"] = 5] = "UnstableConnection";
})(WebRTCTransportErrorCode || (WebRTCTransportErrorCode = {}));
//# sourceMappingURL=WebRTCTransportEvents.js.map